<div class="empty">
  <app-lottie src="/assets/lottie/empty.json" maxWidth="300px"></app-lottie>
  <p class="empty-message">Not Found yet</p>
  <!-- <p class="empty-error">Add from your already created ones</p> -->
</div>
